/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendActualRentDto } from '../../models/backend-actual-rent-dto';

export interface MonitoringActualsRentsCopyCreate$Params {
  id: number;
}

export function monitoringActualsRentsCopyCreate(
  http: HttpClient,
  rootUrl: string,
  params: MonitoringActualsRentsCopyCreate$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendActualRentDto>> {
  const rb = new RequestBuilder(rootUrl, monitoringActualsRentsCopyCreate.PATH, 'post');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendActualRentDto>;
    }),
  );
}

monitoringActualsRentsCopyCreate.PATH = '/api/monitoring/actuals/rents/copy/{id}/';
